import React from 'react';
import { withTranslation } from 'react-i18next';
import configData from './config/config.json';
import './assets/css/App.css';
import Header from "./features/Layout/Header"
import Heading from "./features/Heading/index"
//import GlobalFilters from "./features/FiltersManager/GlobalFilters"
import FiltersManager from "./features/FiltersManager"
//import Intro from "./components/Homepage/Intro"
//import Media from "./components/Homepage/Media"
import Shortcuts from "./features/Shortcuts"
import Footer from "./features/Layout/Footer"
import Deck from "./components/Homepage/Deck"
//import Search from "./features/FiltersManager/Search"
import Cookies from 'universal-cookie';
import Banner from "./features/Banner"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import Promotion from './features/Promotion';
import Media from './features/MediaBox/Media';
import { addLangParam } from './utils/apiHelpers';

//const API_ENDPOINT = 'http://afnu/api/v1/';
const API_ENDPOINT = configData.API_ENDPOINT;
const API_QUERY = "?";//"get/?lang=he";
const cookies = new Cookies();
let API_PREDEFINED_QUERY = "";
let API_OBJECT = "/search/packages/";

class App extends React.Component {

  constructor(props) {
    super(props);

    // Load query string parameters or set default values
    let stars = new URLSearchParams(props.location.search).get("stars")?new URLSearchParams(props.location.search).get("stars").split(','):[];
    let meals = new URLSearchParams(props.location.search).get("meals")?new URLSearchParams(props.location.search).get("meals").split(','):[];
    let holidays = new URLSearchParams(props.location.search).get("holidays")?new URLSearchParams(props.location.search).get("holidays").split(','):[];
    let dates_type = new URLSearchParams(props.location.search).get("dates_type")?new URLSearchParams(props.location.search).get("dates_type"):'';
    let nights = new URLSearchParams(props.location.search).get("nights")?new URLSearchParams(props.location.search).get("nights").split(','):[];
    let from_date = new URLSearchParams(props.location.search).get("from_date")?new URLSearchParams(props.location.search).get("from_date"):'';
    let to_date = new URLSearchParams(props.location.search).get("to_date")?new URLSearchParams(props.location.search).get("to_date"):'';
    let months = new URLSearchParams(props.location.search).get("months")?(new URLSearchParams(props.location.search).get("months")).split(','):[];
    let sortby = new URLSearchParams(props.location.search).get("sortby")?new URLSearchParams(props.location.search).get("sortby"):'price-asc';
    let destinations = (new URLSearchParams(props.location.search).get("destinations")&&new URLSearchParams(props.location.search).get("destinations")!='')==true?new URLSearchParams(props.location.search).get("destinations").split(','):[];
    let country = new URLSearchParams(props.location.search).get("country")?new URLSearchParams(props.location.search).get("country"):'';
    let adults = new URLSearchParams(props.location.search).get("adults")?new URLSearchParams(props.location.search).get("adults"):2;
    let teens = new URLSearchParams(props.location.search).get("teens")?new URLSearchParams(props.location.search).get("teens"):0;
    let children = new URLSearchParams(props.location.search).get("children")?new URLSearchParams(props.location.search).get("children"):0;
    let infants = new URLSearchParams(props.location.search).get("infants")?new URLSearchParams(props.location.search).get("infants"):0;
    let dow = new URLSearchParams(props.location.search).get("dow")?new URLSearchParams(props.location.search).get("dow").split(','):[];
    let airlines = new URLSearchParams(props.location.search).get("airlines")?new URLSearchParams(props.location.search).get("airlines").split(','):[];
    let waterpark = new URLSearchParams(props.location.search).get("waterpark")?true:false;
    let luxury = new URLSearchParams(props.location.search).get("luxury")?true:false;
    let casino = new URLSearchParams(props.location.search).get("casino")?true:false;
    let near_chabad = new URLSearchParams(props.location.search).get("chabad")?true:false;
    let spa = new URLSearchParams(props.location.search).get("spa")?true:false;

    let search = (props.location.pathname == '/search' || props.location.pathname == '/search/')?true:false;
    let active_shortcut = '';
    let heading_text = props.t('homepage.deals.bestDeals')


    this.state = {
      'is_homepage': props?.location?.pathname == '/' || props?.location?.pathname == '/best-deals/',
      'heading_text': heading_text,
      'active_shortcut': active_shortcut,
      'categories' : [],
      'country': country,
      'carousel_items': [],
      'isLoading'   : true,
      'error'       : null,
      'show_destinations_popup': false,
      'showFloatingMedia': false,
      'mediaEnabled': false, // F005: floating media popup disabled (old site is the opt-in default)
      'filters' : {
        'window': {
          'visible': search,
          'active_tab': 'search',
          'refresh_count': 0,
          'step': '0'
        },
        'origin': {
          'iata': {
            'TLV': true,
            'ETM': false
          },
        },
        'from_airport'  : 'TLV',
        'stars'         : stars,
        'meals'         : meals,
        'holidays'      : holidays,
        'dates_type'    : dates_type,
        'nights'        : nights,
        'from_date'     : from_date,
        'to_date'       : to_date,
        'limit'         : 10,
        'destination_name': props.t('homepage.deals.allDestinations'),
        'destinations'  : destinations,
        'country'       : country,
        'sortby'        : sortby,
        'months'        : months,
        'adults'        : adults,
        'teens'         : teens,
        'children'      : children,
        'infants'       : infants,
        'dow'           : dow,
        'airlines'      : airlines,
        'highlights'    : {
          'waterpark'     : waterpark,
          'luxury'        : luxury,
          'near_chabad'   : near_chabad,
          'spa'   : spa,
          'casino'        : casino
        }
      },
      cities: [],
      heading_key: 0
    }
    
    // binding
    this.getFilters = this.getFilters.bind(this); 
    this.fetchDestinations = this.fetchDestinations.bind(this);
    this.updateDestinations = this.updateDestinations.bind(this); 
    this.showSearchWindow = this.showSearchWindow.bind(this);
    this.closeSearchWindow = this.closeSearchWindow.bind(this);
    this.handleClose = this.handleClose.bind(this); 
    //this.openSearch = this.openSearch.bind(this);
    this.showDestinationSelectionPopup = this.showDestinationSelectionPopup.bind(this);
    this.handleCloseSearchWindow = this.handleCloseSearchWindow.bind(this);
    this.gotoStep = this.gotoStep.bind(this); 
    

    //https://stackoverflow.com/questions/54245395/how-can-i-scroll-to-a-div-onclick-using-react
    this.myDivToFocus = React.createRef()
    this.resultsPaneRef = React.createRef()
    
    // Save last visit date in a cookie
    cookies.set('last_visit', this.formatDate(new Date()), {
        path: '/',
        expires: new Date('9999-12-31')
    })

    // Save visits counter
    cookies.set('visits', cookies.get('visits')?parseInt(cookies.get('visits'))+1:1, {
        path: '/',
        expires: new Date('9999-12-31')
    })

    
  }

  componentDidMount() {
    //console.log('componentDidMount')
    this.refetchData()

    // Add scroll listener
    window.addEventListener('scroll', this.handleScroll);

    
  }


  componentWillUnmount() {
        // Remove scroll listener
        window.addEventListener('scroll', this.handleScroll);
  }

  objectToQueryString(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  handleScroll = (e) => {

    e.preventDefault();
    e.stopPropagation();
    
    //console.log('handleScroll')
    const scrollPosition = window.scrollY;
    const urlParams = new URLSearchParams(window.location.search);

    if ( this.state.mediaEnabled && (urlParams.get('media') !== null || this.state?.is_homepage)) {
        if (scrollPosition > 1000 && !this.state?.showFloatingMedia) {  
            this.setState(prevState=>(
                {
                  ...prevState,
                  showFloatingMedia: true,
                  mediaKey: (prevState.mediaKey || 0) + 1
                }
            ), ()=>{});

        }
    }
  };

  handleCloseMedia = () => {
        this.setState(prevState => (
        {
            ...prevState,
            showFloatingMedia: false,
            mediaEnabled: false
        }));

        cookies.set('media_closed','1',{ 
            path: '/' ,
            maxAge: 86400 * 2 // 2 days
        })
  };

  refetchData(updateURL=false) {
    console.log('Refetch1')
    console.log(this.props.location)
    console.log(this.state.filters)
    
    // Focus results section
    if (updateURL) this.resultsPaneRef.current.focus()
    
    this.query_options = new Map();
    this.query_options.set('stars',this.state.filters.stars);
    this.query_options.set('meals',this.state.filters.meals);
    this.query_options.set('holidays',this.state.filters.holidays);
    this.query_options.set('dates_type',this.state.filters.dates_type);
    this.query_options.set('nights',this.state.filters.nights);
    this.query_options.set('from_airport',this.state.filters.from_airport);
    this.query_options.set('months',this.state.filters.months);
    this.query_options.set('sortby',this.state.filters.sortby);
    this.query_options.set('from_date',this.state.filters.from_date);
    this.query_options.set('to_date',this.state.filters.to_date);
    this.query_options.set('adults',this.state.filters.adults);
    this.query_options.set('teens',this.state.filters.teens);
    this.query_options.set('children',this.state.filters.children);
    this.query_options.set('infants',this.state.filters.infants);
    this.query_options.set('dow',this.state.filters?.dow);
    this.query_options.set('airlines',this.state.filters?.airlines);
    this.query_options.set('destinations',this.state.filters?.destinations);
    this.query_options.set('country',this.state.filters?.country);
    this.query_options.set('waterpark',this.state.filters?.highlights?.waterpark);
    this.query_options.set('luxury',this.state.filters?.highlights?.luxury);
    this.query_options.set('casino',this.state.filters?.highlights?.casino);
    this.query_options.set('chabad',this.state.filters?.highlights?.near_chabad);
    this.query_options.set('spa',this.state.filters?.highlights?.spa);

    if (this.props.location.pathname == '/') {
        this.query_options.set('source', 'homepage')
    } else {
        this.query_options.set('source', 'category'); 
        // extract the category name from the pathname and strip all the slashes from the name
        this.query_options.set('source_sub', this.props.location.pathname.replace(/^\/|\/$/g, ''));
    }

    

    //let querystring = "";
    //this.query_options.forEach((value,key) => querystring+=`&${key}=${value}`) ;

    let querystring_array = [];

    // Remove empty keys
    // Sort values (if array)
    this.query_options.forEach((value,key) => {
      if (value && value!='') {
          if (Array.isArray(value))
            value = value.sort();

          querystring_array.push(`${key}=${value}`)  
      }
    });

    // Sort result array by keys & rebuild querystring
    const querystring=querystring_array.sort((a,b)=>a-b).join('&');

    const baseUrl =  API_ENDPOINT + API_OBJECT + API_QUERY + querystring + API_PREDEFINED_QUERY
    const url = addLangParam(baseUrl);

    // Should the URL indicate the filters
    if (updateURL)
      this.props.history.push("/best-deals/" + API_QUERY + querystring + API_PREDEFINED_QUERY)

    return (
      fetch(url)
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error('Sorry, we couldn\'t get response from the remote server, please try again in few seconds (Error 303)');
        }
      })
      .then(data =>  {


        //console.log(this.state.filters)

        // Randomize deals in every category and slice first 7
        data.categories.map(cat => {

            // RandomValue should get a value between 0-1, randomized on a daily basis and incorporate cat.priority (which is between 1-7).
            const RandomValue = (function() {
              const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
              const seed = parseInt(today.replace(/-/g, ''), 10) * cat.priority;
              const x = Math.sin(seed) * 10000;
              return x - Math.floor(x);
            })();

            if (cat.id != 'best-deals') {
                // If we're browsing using a mobile device (screen width is smaller than 500 px) => show only 5 results, otherwise, show 7 results
                if (window.innerWidth < 500) {
                    cat.deals = cat.deals.sort(() => RandomValue - 0.5).slice(0, 5).sort((a, b) => a.price - b.price)
                } else {
                    cat.deals = cat.deals.sort(() => RandomValue - 0.5).slice(0, 7).sort((a, b) => a.price - b.price)
                }
            } else {
                // Show real top 7 best-deals (dont randomize results)
                cat.deals = cat.deals.sort((a,b)=>a.price-b.price);
            }
        });

        this.setState(prevState => (
        {
          ...prevState,
          'categories': data.categories,
          'isLoading': false, 
          filters: {...this.state.filters }
       }));

       // Focus on results page after deals finished loading
       //if (updateURL) this.resultsPaneRef.current.focus()
        
      })
      .catch(error=>this.setState(prevState => (
          {
            ...prevState,
            error, 
              'isLoading': false,
              filters: {...this.state.filters },
          }
      ))
      )
    );  
  }


      
  async fetchDestinations() {

    console.log(`Fetch destinations`)
    const API_ENDPOINT = configData.API_ENDPOINT;
    const baseUrl = `${API_ENDPOINT}/search/destinations/`;
    const url = addLangParam(baseUrl);

    const results = await fetch(url)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Sorry, we couldn\'t get response from the remote server, please try again in few seconds (Error 303)');
          }
        })

    this.setState(prevState=>(
      {
        ...prevState,
        'all_destinations': results
      }
    ))

}


  getFilters(filtersVal, updateURL=false) {
    //console.log('getFilters()')
    //console.log(JSON.stringify(filtersVal))
    // JAVASCRIPT ERROR: Cannot convert object to primitive value => which means it fails to convert the QS object to string 
    // BUGFIX: not filtering after filtering and then  refreshing the page and then selecting destination 
    filtersVal.QS = null;

     // If user selected only 1 destination, go directly to deals page of this destination
//     alert(filtersVal.destinations)

    //  Before I added this, when I was redirecting the user to another page, the target url contains many junk parameters... 
    const excludedKeys = new Set(["window", "origin", "destination_name", "showDestinationsWindow", "rooms", "highlights", "limit", "country","sortby","QS"]);

    //const queryString = Object.keys(filtersVal).map(key => key + '=' + filtersVal[key]).join('&');
    const queryString = Object.keys(filtersVal)
        .filter(key => !excludedKeys.has(key)) // Exclude unwanted keys
        .map(key => `${key}=${filtersVal[key]}`) // Encode values properly
    .join('&');
    
    // extract highlights
    let highlights = "";
    if (filtersVal.highlights) {
        highlights = Object.entries(filtersVal.highlights)
            .filter(([key, value]) => value === true || value === '1' || value === 1) // Only keep valid entries
            .map(([key, value]) => `${key}=${value}`) // Map to key=value
            .join("&"); // Join with '&' only between valid entries
    }


    if (filtersVal.destinations && filtersVal.destinations.length==1) {
        if ((filtersVal.months && filtersVal.months.length == 1) || (filtersVal.from_date.length > 0 && filtersVal.to_date.length > 0)) {
            // If we've searched for 1 destination + 1 month => skip the months page and go directly to the deals index page
            // OR we've selected 1 destination + dates range => skip the months page and go directly to the deals index page
            window.location = `/${this.props.t('common.paths.deals')}/${this.props.t('common.paths.custom')}/?` + queryString.replace('months=','month=') + '&' + highlights;
        } else {
            console.log('Redirecting to destination page')
            window.location = `/${this.props.t('common.paths.deals')}/?` + queryString + '&' + highlights;
        }
     }

    if  (filtersVal.destination!=null && filtersVal.destination!='null' && filtersVal.destination!=null && filtersVal.destination!='' && filtersVal.destination!=null && filtersVal.destination!='all') {

      console.log(`Multiple destination selected: ${filtersVal.destination}`)
      //console.log(filtersVal)
      //console.log(queryString)
      
      if (filtersVal?.when=='dates' || filtersVal?.when=='months') {
        // if destination changed but also specific dates / months selected go directly to the month results page
        window.location = '/' + filtersVal.destination_name  + '/'+filtersVal.when_caption+'/?' + queryString
      } else {
        window.location = '/' + filtersVal.destination_name  + '?' + queryString        
      }

      return
    }
  
    //.current is verification that your element has rendered
    if(this.myDivToFocus.current){
      this.myDivToFocus.current.scrollIntoView({ 
         behavior: "smooth", 
         block: "nearest"
      });
      this.myDivToFocus.current.focus({preventScroll: true});
      
    }

    console.log('Saving filters...')
//    console.log(JSON.stringify(filtersVal))
    

    this.setState(prevState=>(
      {
        ...prevState,
        'destinations': [] ,
        'isLoading': true, 
        'heading_text': this.props.t('homepage.deals.customized'),
        'filters': filtersVal,
        
      }),
      () => this.refetchData(updateURL)
    );    

    //document.getElementById('results_pane').current.focus();
  }


  /**
   * 
   * @param {*} step 
   * @param {*} next_step_close 
   */
  showSearchWindow(step='0', next_step_close=false) {
    console.log('Show search wizard ' + step)

    this.setState((prevState) => (
      {
          ...prevState,
          filters: {
              ...prevState.filters,  
              'window': {
                  ...prevState.filters.windows,
                  'visible': true,
                  'active_tab': 'search',
                  'step': step,
                  'next_step_close': next_step_close
              }
          }            
      }
  ));
}

closeSearchWindow() {
  this.setState((prevState) => (
    {
        ...prevState,
        filters: {
            ...prevState.filters,  
            'window': {
                ...prevState.filters.windows,
                'visible': false,
            }
        }            
    }
));
}

  /*openSearch(event) {

    this.refreshChildState()
    
    console.log('Show search wizard ')
    this.setState(prevState=> ({
      ...prevState,
      //'destinations': this.state.destinations,
      //'isLoading': false, 
      filters: {
        ...prevState.filters,
        'window': {
          ...prevState.filters.window,
          'visible': true,
          //'refresh_count': this.state.filters.window.refresh_count?this.state.filters.window.refresh_count++:0,
        },
       }
   }));
  }*/

  handleClose() {
    //alert('closing')

    /*cookies.set('welcomed',1,{ 
      path: '/' ,
      maxAge: 86400 * 120 // 120 days
    })*/

    cookies.set('welcomed','1',{ 
      path: '/' ,
      maxAge: 86400 * 120 // 120 days
    })
    
  }
    
  showDestinationSelectionPopup() {

    this.setState(prevState=>{
      return {
        ...prevState,
        'show_destinations_popup': true,
        'heading_key': ++prevState.heading_key
      }
    })
  }

  handleClose() {
    
    this.setState(prevState => (
    {
      ...prevState,      
      'destinations': this.state.destinations, 
      'isLoading': false, 
      filters: {
        ...this.state.filters,
        'window': {
          ...this.state.filters.window,
          visible: false,
        }
      },
    }))
  }
    

  handleCloseSearchWindow() {
    console.log('handleCloseSearchWindow')
    this.setState((prevState)=>({
        ...prevState,
        filters: {
          ...prevState.filters,
          window: {
            ...prevState.filters.window,
            visible: false
          }
        }
      })
    )
  }

  /**
   * Once we've fetched the destinations list, update the state so we can use it in other places
   * @param {*} dest 
   */
  updateDestinations(cities) {

      this.setState(prevState=>(
        {
          ...prevState,
          'cities': cities,
        }
      ),
      () => {
        //console.log(dest)
        //console.log(this.state)
      }
    )
  }
  
  /**
   * Invoked by clcking the search icon in the top navigation bar
   */
  /*showSearchWindow(show) {
    
    this.setState(prevState=>(
      {
        ...prevState,
        filters: {
          ...prevState.filters,
          window: {
            ...prevState.filters.window,
            visible: show
          }
        }
      }
    ))
  }*/

 
  /**
   * Function will check if it is weekend in Israel (Friday/Sat)
   * @param {*} date 
   * @returns 
   */
  isWeekend(date = new Date()) {

      //return false; // disabled

      const d = new Date();
      const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
      const offset = 3; // Use UTC+3 time = Israel's time
      const nd = new Date(utc + (3600000*offset));
      
      return nd.getDay() === 5 || nd.getDay() === 6;
  }

  gotoStep = (e, step, next_step_close=false) => {
    console.log('gotoStep', step)
    e.stopPropagation()

    // If we've click the step 1 button but it's empty jumpt to step 2
    if (step=='2') {
        if (this.state.filters?.dates_type==='exact'|| (this.state.filters?.holidays?.length>0 && !this.state.filters.holidays.find(holiday=>holiday.includes('school-summer-vacation'))) )
            step='3';
    }

    this.setState((prevState) => (
        {
           ...prevState,
            filters: {
                ...prevState.filters,  
                'window': {
                    ...prevState.filters.window,
                    'step': step+'',
                    'visible': true,//prevState.filters?.window?.visible?prevState.filters?.window?.visible:false,
                    'next_step_close': next_step_close
                    //'active_tab': 'search'
                }
            }            
        }
    ),()=>{
      console.log(this.state.filters)
    })
}

hideFloatingTopBanner(e) {
  this.setState(prevState=>({
   ...prevState,
    'floating_top_banner': {
     ...prevState.floating_top_banner,
      visible: 'no'
    }
  }))
  console.log('hideFloatingTopBanner')
  cookies.set('welcomed','1',{
    path: '/' ,
    maxAge: 60 * 60 * 24 * 45 // 45 days
  })

}

formatDate(date) {
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0') + 'T' +
      String(date.getHours()).padStart(2, '0') + ':' +
      String(date.getMinutes()).padStart(2, '0') + ':' +
      String(date.getSeconds()).padStart(2, '0') + '.' +
      String(date.getMilliseconds()).padStart(3, '0');
}
  

hidePopup(e) {
  this.setState(prevState=>({
   ...prevState,
    'popup_banner': {
     ...prevState.popup_banner,
      visible: 'no'
    }
  }))
  console.log('hide popup_banner')
  cookies.set('popup','1',{
    path: '/' ,
    maxAge: 86400 / 24 // 1 hour
  })

}

  render() {
    const { t } = this.props;
    console.log('render homepage')
    // conditional rendreing ahead
    const {error} = this.state;

    if (error) {
      return <p>{error.message}</p>;
    }

    let strActiveMenu = "main";
    let hideMainImage = "";
    if (window.location.pathname==="/last-minute") {
      strActiveMenu = "last-minute";
      hideMainImage = true;
    }


      //let hideHomepageIntro = this.props?.location?.search && this.props?.location?.search!=null;
      let hideHomepageIntro = (
        !new URLSearchParams(this.props.location.search).get("intro") && (
        new URLSearchParams(this.props.location.search).get("min_nights") ||
        new URLSearchParams(this.props.location.search).get("max_nights") ||
        new URLSearchParams(this.props.location.search).get("nights") ||
        new URLSearchParams(this.props.location.search).get("stars") ||
        new URLSearchParams(this.props.location.search).get("min_stars") || 
        new URLSearchParams(this.props.location.search).get("max_stars") || 
        new URLSearchParams(this.props.location.search).get("min_price") || 
        new URLSearchParams(this.props.location.search).get("max_price") || 
        new URLSearchParams(this.props.location.search).get("when") || 
        new URLSearchParams(this.props.location.search).get("from_date") || 
        new URLSearchParams(this.props.location.search).get("to_date") || 
        new URLSearchParams(this.props.location.search).get("dates") || 
        new URLSearchParams(this.props.location.search).get("months") || 
        new URLSearchParams(this.props.location.search).get("months_weekends") || 
        new URLSearchParams(this.props.location.search).get("sortby") || 
        new URLSearchParams(this.props.location.search).get("waterpark") || 
        new URLSearchParams(this.props.location.search).get("luxury") || 
        new URLSearchParams(this.props.location.search).get("casino") || 
        new URLSearchParams(this.props.location.search).get("chabad") || 
        new URLSearchParams(this.props.location.search).get("destination")) 
        
      );

      let searchResults = false;
      if (hideHomepageIntro) 
          searchResults = true;

      const urlParams = new URLSearchParams(window.location.search);
      const showPopup = urlParams.get('popup')!=null ;
      
      // ENABLE / DISABLE floating top banner only once
      const boolShowTopBanner = false;
      return (
      <div style={{backgroundColor:'#f5f5f5'}}>
        {boolShowTopBanner?(
            <div id="floating_top_banner" className="floating_top_banner"  
                style={
                    {
                    display: (!this.state?.floating_top_banner?.visible || this.state?.floating_top_banner?.visible=='yes') && !cookies.get('welcomed')?'flex':'none',
                    justifyContent:'space-between', 
                    alignItems:'top', 
                    width: '100%',
                    background: '#f4d956', 
                    fontWeight: 800, 
                    fontSize: '18px',
                    color: '#333', 
                    
                    zIndex: 1000, 
                    height: '80px',
                    padding: '.5em'
                    }
                }>
                    <div id="closeButton">
                        <button tabIndex="1" style={{border:'1px solid #aaa', background:'none'}} title={t('homepage.deals.hideAd')} onClick={e=>{this.hideFloatingTopBanner(e)}} >
                            <FontAwesomeIcon icon={faTimes} size="1x" style={{color:'#000', cursor:'pointer'}}/>
                        </button>
                    </div>
                    <div style={{width:'100%'}}>
                    <p style={{ lineHeight: 1.25, marginBottom:0}}><span style={{fontWeight:800,color:'#bc2a2a'}}>{t('homepage.deals.newInAfnu')}</span> {t('homepage.deals.cancellationInsurance')}  <br />{t('homepage.deals.upTo6Hours')}</p>
                    <p style={{marginBottom:0, marginTop: '.5em', fontSize:'.7em', fontWeight: 400}}>{t('homepage.deals.moreDetailsInBooking')}</p>
                    </div>
            </div>
        ):null}
        
        <Promotion campaign='blackfriday2025' show={showPopup} />
        
        <div className="App">
                
          <Header 
            t={this.props.t}    
            activeMenu={strActiveMenu} 
            hide={hideMainImage} 
            className="hidden" 
            openSearchWindow={this.showSearchWindow} 
            location={this.props?.location} 
            hidden={this.props.hidden} 
            hideHomepageIntro={hideHomepageIntro} 
            filters={this.state?.filters}
            style={{marginTop:!this.state?.floating_top_banner && !cookies.get('welcomed')?'80px':'0px'}} />

          <main className="homepage_main">
              {/*<Carousel data={this.state.carousel_items} isLoading={this.state.isLoading}  hidden={hideHomepageIntro} />*/}
              <div style={{boxShadow:'#5555551a 0px 5px 15px 0px'}}>
                <Shortcuts   openSearchClicked={this.showSearchWindow} hidden={!searchResults && hideHomepageIntro} hideHeader={searchResults} filters={this.state.filters} active={this.state.active_shortcut} searchResults={searchResults} />
              </div>
              <a name="deals"></a>
              <div className='wave'>
                <svg viewBox="0 0 1500 62" fill="none" xmlns="http://www.w3.org/2000/svg" style={{minHeight:'40px'}}>
                  <path transform="scale(1)" fillRule="evenodd" clipRule="evenodd" d="M2748.4,38.1c-211.5-0.3-438.7,84.6-634.5-0.8c-190-82.9-394.4,85.4-609.5-0.7c-204.9-82.1-433,86.2-650.9-0.8
          C659-41.9,412.2,122.7,235.7,35c-157-78-314.4,87.7-513-0.6C-444.1-39.8-635.1,34-814,33.7v89h3562.4V38.1z" fill="#eee"></path></svg>
              </div>
                
              <Banner campaign='rosh25' hide={true || !this.isWeekend()} t={this.props.t} />
              {/*<div>
                <img style={{margin:'0 auto 1.5em', width:'95%', maxWidth:'450px', border:'1px solid #aaa'}} src={'/images/banners/israeli-airlines.jpg'} alt="הודעה: אצלנו נותנים עדיפות לחברות תעופה שממשיכות לטוס לישראל למרות המצב הבטחוני"  />
              </div>*/}
              
              
                  
            <div ref={this.resultsPaneRef} tabIndex="0">
                <FiltersManager 
                    t={this.props.t}
                    hide_bar={true}
                    filters={this.state.filters} 
                    openSearch={this.state.filters?.window?.visible?this.state.filters?.window?.visible:false} 
                    destinations={this.state?.all_destinations} 
                    sendDataToCaller={this.getFilters} 
                    showSearchWindow={this.showSearchWindow} 
                    closeSearchWindow={this.closeSearchWindow}
                    gotoStep={this.gotoStep}
                    location={this.props.location} 
                    month_name={this?.month_name} 
                    months={this.months} 
                    motn={this.month}
                    fetchDestinations={this.fetchDestinations}
                    year={this.year}></FiltersManager>

                <div className={'preloader ' + (this.state.isLoading?' show-item':' hide-item')} tabIndex="0" autoFocus={true}>
                    <FontAwesomeIcon icon={faSpinner} spin size="3x" style={{margin:'.5em auto'}} title={t('homepage.deals.loading')} />
                </div>
                {
                    JSON.parse(JSON.stringify(this.state.categories)).sort((a,b)=>a.priority-b.priority).map((cat, index)=>{
                        if (cat.id=='best-deals')
                            cat.deals = cat.deals.slice(0,7);

                        if (cat.id=='featured')
                            return (<div key={`group${index}`} style={{background:'#fff',padding:'1.5em 0 1px',margin: '0',boxShadow:'#55555555 0px 5px 15px 0px'}}>
                                    <Heading key={'header'+index} sendDataToCaller={this.updateDestinations} source='homepage' show_popup={this.state?.show_destinations_popup} destinations={this.state.cities} destination={this.state?.destination} destination_id={this.state?.destination?.city_id} destination_name={this.state?.destination?.city_name} filters={this.state.filters} text={cat.name} subheader={cat.description && cat.description!='' ? cat.description : null} t={this.props.t} />
                                    <Deck style={{marginBottom:'10px'}} target_url={cat.target_url} target_name={cat.name} category_id={cat.id} source='homepage' autoFocus={true} data={new Array(cat)} key={`deck${index}`} tabIndex="0" cities={this.state?.cities} ready={!this.state.isLoading} type="hotels" meals={this.state?.filters?.meals} nights={this.state?.filters?.nights}  stars={this.state?.filters?.stars} waterpark={this.state?.filters?.highlights?.waterpark} luxury={this.state?.filters?.highlights?.luxury} casino={this.state?.filters?.highlights?.casino} near_chabad={this.state?.filters?.highlights?.near_chabad} spa={this.state?.filters?.highlights?.spa} from_date={this.state?.filters?.from_date} to_date={this.state?.filters?.to_date} dates_type={this.state?.filters?.dates_type} months={this.state?.filters?.months} dow={this.state?.filters?.dow} airlines={this.state?.filters?.airlines} t={this.props.t} />
                                </div>)
                        else
                            return (<div key={`group${index}`} style={{background:'#fff',padding:'1.5em 0 1px',margin: '0',boxShadow:'#55555555 0px 5px 15px 0px'}}>
                                <Heading key={'header'+index} sendDataToCaller={this.updateDestinations} source='homepage' show_popup={this.state?.show_destinations_popup} destinations={this.state.cities} destination={this.state?.destination} destination_id={this.state?.destination?.city_id} destination_name={this.state?.destination?.city_name} filters={this.state.filters} text={cat.name} subheader={cat.description && cat.description!='' ? cat.description : null} t={this.props.t} />
                                <Deck style={{marginBottom:'10px'}} target_url={cat.target_url} target_name={cat.name} category_id={cat.id} source='homepage' autoFocus={true} data={new Array(cat)} key={`deck${index}`} tabIndex="0" cities={this.state?.cities} ready={!this.state.isLoading} type="hotels" meals={this.state?.filters?.meals} nights={this.state?.filters?.nights}  stars={this.state?.filters?.stars} waterpark={this.state?.filters?.highlights?.waterpark} luxury={this.state?.filters?.highlights?.luxury} casino={this.state?.filters?.highlights?.casino} near_chabad={this.state?.filters?.highlights?.near_chabad} spa={this.state?.filters?.highlights?.spa} from_date={this.state?.filters?.from_date} to_date={this.state?.filters?.to_date} dates_type={this.state?.filters?.dates_type} months={this.state?.filters?.months} adults={cat?.adults} teens={0} children={cat?.children} infants={0} dow={this.state?.filters?.dow} airlines={this.state?.filters?.airlines} t={this.props.t} />
                            </div>)
                    }) // map
                }

                <div style={{background:'#fff',padding:'1.5em 0',margin: '20px 0',boxShadow:'#55555555 0px 5px 15px 0px' }}>
                    <Heading key={'header'+this.state?.heading_key} sendDataToCaller={this.updateDestinations} source='homepage' show_popup={this.state?.show_destinations_popup} destinations={this.state.cities} destination={this.state?.destination} destination_id={this.state?.destination?.city_id} destination_name={this.state?.destination?.city_name} filters={this.state.filters} text={t('homepage.deals.allOurDestinations')} subheader={t('homepage.deals.pricesInclude')} t={this.props.t} />
                    <div className='all_destinations_block'>
                        {this.state.categories && this.state.categories.filter(cat=>cat.id=='best-deals').length>0 ? 
                            this.state.categories.filter(cat=>cat.id=='best-deals')[0].deals.sort((a,b)=>a.price-b.price).map((deal, idx)=>{
                                return (
                                        <a href={`/${deal.destinations.city[0].name}/?destinations=${deal.destinations.id}`} title={`${t('homepage.deals.dealsTo')}${deal.destinations.city[0].name}`} style={{textDecoration:'none'}} key={`a${idx}`}>

                                                <div
                                                    className="destination_block"
                                                    style={{backgroundImage: `url(https://cdn.cookiecrumbz.com/images/destinations/${deal.destinations?.uid}.jpg)`}}
                                                >
                                                <div className="destination-block-overlay"></div>

                                                <div className="destination-block-content">
                                                    <div className="destination-block-name">{deal.destinations.city[0].name}</div>
                                                    <div className="destination-block-price">
                                                        <span>{t('common.labels.startingFrom')}</span>
                                                        <span className="destination-block-amount">${Math.ceil(deal.price / deal.passengers_count)}</span>
                                                    </div>
                                                </div>
                                                </div>
                                        </a>
                                )
                            }):
                            (<></>)
                        }
                        </div>
                </div>
              
            </div>
            </main>
            <Footer hide={(this.state.isLoading?true:false)} t={this.props.t} />
            { this.state.showFloatingMedia && this.state.mediaEnabled && !cookies.get('media_closed')? (
                <div className="floating-media visible">
                    <div className="header">
                        <a style={{textDecoration:'none'}} href="/article/media"><h3 className="title">{t('homepage.deals.talkAboutUs')}</h3></a>
                        <button
                            className="close-button"
                            onClick={this.handleCloseMedia}
                            aria-label={t('common.accessibility.closeMedia')}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    <Media key={this.state?.mediaKey} t={this.props.t} />
                </div>
            ):(<></>)}

          </div>
      </div>
      );
    }
  }

export default withTranslation()(App);